import type { Payment } from '../types/GrooverTypes'
import { PaymentSource } from '../types/GrooverTypes'

/**
 * Recognize any reception walk-in payment — Swish QR or Stripe Terminal card (Firestore may
 * return source as plain string).
 *
 * Deliberately excludes `PaymentSource.StripeTerminal` (COU-325 Trigger Pay): that source is a
 * card-present payment against an **existing** enrollment, taken via Reception's Trigger Pay
 * flow, and never creates a new enrollment or checks anyone in — the two things that define a
 * walk-in here. This exclusion is intentional, not an oversight; do not add it below.
 */
export const isWalkInPayment = (p: Payment): boolean => {
  if (p.type === 'refund') return false
  if (p.type != null && p.type !== 'pay') return false
  const raw = p.source as string | undefined
  if (raw == null) return false
  const norm = String(raw).trim().toLowerCase()
  return (
    norm === String(PaymentSource.SwishWalkIn).toLowerCase() ||
    norm === String(PaymentSource.StripeWalkIn).toLowerCase()
  )
}
